export default {"src":"/_next/static/media/flickr.c118af4d.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};